import React, { useState, useEffect } from "react"
import gsap from "gsap"

import style from "./StarRating.module.scss"

type StarRatingProps = {
  rating: number
  height?: number
  gap?: number
  colour?: string
  show: boolean
}

const Star = ({ rating, height, gap, colour }: StarRatingProps) => {
  const [containerStyle, setContainerStyle] = useState({})
  const [starStyle, setStarStyle] = useState({})

  useEffect(() => {
    let newStyle = { ...containerStyle }
    if (height) newStyle = { ...newStyle, width: `${height}px`, height: `${height}px` }
    if (gap) newStyle = { ...newStyle, margin: `0 ${gap / 2}px` }
    setContainerStyle(newStyle)
  }, [height, gap])

  useEffect(() => {
    colour && setStarStyle({ backgroundColor: colour })
  }, [colour])

  return (
    <div className={`star ${style.starContainer}`} style={containerStyle}>
      <div className={style.emptyStar} style={starStyle} />
      <div className={style.filledStar} style={{ width: `${rating * 100}%`, ...starStyle }} />
    </div>
  )
}

const StarRating = (props: StarRatingProps) => {
  const [stars, setStars] = useState<React.ReactNode[]>()

  // TODO: This will only work when there is 1 star rating component in the page. We should update to use refs or unique-ids.
  // useEffect(() => {
  //   gsap.to(".star", { y: 0, opacity: 1, stagger: 0.15, delay: 2 })
  // }, [stars, props.show])

  useEffect(() => {
    const { rating } = props
    let starArray = []

    const fullStars = Math.floor(rating)
    for (let i = 0; i < fullStars; i++) {
      starArray.push(<Star {...props} key={`full-star-${i}`} rating={1} />)
    }

    const partialStar = rating % 1
    partialStar && starArray.push(<Star key={`part-star`} {...props} rating={partialStar} />)

    const emptyStars = Math.floor(5 - rating)
    for (let i = 0; i < emptyStars; i++) {
      starArray.push(<Star {...props} key={`empty-star-${i}`} rating={0} />)
    }

    setStars(starArray)
  }, [props.rating])

  return <div className={style.stars}>{stars}</div>
}

export default StarRating
